
export default {
  layout: {
    "rows": [
      {
        "fields": [ { "name": "institute.name" } ]
      }
    ]
  }
}
